// extracted by mini-css-extract-plugin
module.exports = {"priceWrapper":"SalePrice_priceWrapper__SVe65","regularPriceLabel":"SalePrice_regularPriceLabel__51XCF","savePrice":"SalePrice_savePrice__KmcE3"};